var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VirtualList',{staticClass:"virtual-list",attrs:{"data-key":_vm.dataKey,"data-sources":_vm.nodes,"data-component":_vm.VirtualItem,"item-class":"tree-item","extra-props":{
    formula: _vm.formula,
  },"keeps":200,"estimate-size":66},on:{"onTagClick":function($event){return _vm.$emit('onTagClick', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }